import { render, staticRenderFns } from "./ProgramServiceAssignmentEditor.vue?vue&type=template&id=8eb7eaa6&scoped=true&"
import script from "./ProgramServiceAssignmentEditor.vue?vue&type=script&lang=js&"
export * from "./ProgramServiceAssignmentEditor.vue?vue&type=script&lang=js&"
import style0 from "./ProgramServiceAssignmentEditor.vue?vue&type=style&index=0&id=8eb7eaa6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eb7eaa6",
  null
  
)

export default component.exports